import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert } from '../models/generic/alert.model';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

    private readonly alertTimeout: number = 10000;

    private alert: Alert | undefined;
    alert$ = new Subject<Alert>();

    displayAlertSuccess(message: string) {
        this.alert = new Alert();
        this.alert.type = 'success';
        this.alert.message = message;
        this.alert.timeout = this.alertTimeout;

        this.emitAlert();
    }

    displayAlertInfo(message: string) {
        this.alert = new Alert();
        this.alert.type = 'info';
        this.alert.message = message;
        this.alert.timeout = this.alertTimeout;

        this.emitAlert();
    }

    displayAlertError(message: string) {
        this.alert = new Alert();
        this.alert.type = 'danger';
        this.alert.message = message;
        this.alert.timeout = this.alertTimeout;

        this.emitAlert();
    }

    private emitAlert() {
        this.alert$.next(this.alert!);
    }
}
